import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card, CardContent, CardHeader } from "components/ui";

const CmsFormSkeleton = memo(({ showHistory = false }) => {
  return (
    <Card>
      {showHistory && (
        <CardHeader className="flex flex-row justify-end">
          <Skeleton
            variant="rounded"
            width={80}
            height={40}
            sx={{ borderRadius: "6px" }}
          />
        </CardHeader>
      )}
      <CardContent>
        <div className="px-5">
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="rounded" width="100%" height={36} />
        </div>

        <div className="p-5 py-2">
          <div className="mb-2">
            <Skeleton variant="text" width={100} height={24} />
          </div>

          <div className="overflow-hidden rounded-lg border">
            <div className="flex items-center gap-3 border-b p-3 overflow-hidden">
              {Array.from({ length: 8 }, (_, index) => (
                <Skeleton
                  key={index}
                  variant="rounded"
                  width={20}
                  height={20}
                  sx={{ flexShrink: 0 }}
                />
              ))}
            </div>

            <div className="min-h-[180px] space-y-3 p-4">
              <Skeleton variant="text" width="75%" height={22} />
              <Skeleton variant="text" width="50%" height={22} />
              <Skeleton variant="text" width="65%" height={22} />
            </div>
          </div>
        </div>

        <div className="p-5 py-2 flex justify-end">
          <Skeleton
            variant="rounded"
            width={96}
            height={40}
            sx={{ borderRadius: "6px" }}
          />
        </div>
      </CardContent>
    </Card>
  );
});

CmsFormSkeleton.displayName = "CmsFormSkeleton";

export default CmsFormSkeleton;
